import { NavLink } from 'react-router-dom';

export default function HelpLink({
    id,
    children,
    ...rest
}: {
    id: string;
    children?: React.ReactElement;
}) {
    return (
        <NavLink exact to={`/${id}`} activeClassName="active" replace {...rest}>
            {children}
        </NavLink>
    );
}
